import script from "./UserHome.vue?vue&type=script&setup=true&lang=js"
export * from "./UserHome.vue?vue&type=script&setup=true&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=449eabaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449eabaa"]])

export default __exports__